<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="个人统计" name="first">
        <tab-person/>
      </el-tab-pane>
      <el-tab-pane :is-department="activeName" label="部门统计" name="second">
        <tab-department/>
      </el-tab-pane>
      <el-tab-pane label="个人议事规则执行情况" name="third">
        <personRole />
      </el-tab-pane>
      <el-tab-pane label="部门议事规则执行情况" name="fourth">
        <departmentRole />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import tabPerson from './countPerson'
import tabDepartment from './countDepartment'
import personRole from './personRole'
import departmentRole from './departmentRole'
// import { mapGetters } from 'vuex'
export default {
  components: {
    'tab-person': tabPerson,
    'tab-department': tabDepartment,
    personRole,
    departmentRole
  },
  data() {
    return {
      activeName: '',
      searchForm: {
        time: []
        // workcode:[]
      },
      loading: false,
      dataList: [],
      allUsers: [],
      userList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      today: ''
    }
  },
  created() {
    this.activeName = this.$store.state.countParams.panelName
  },
  beforeMount() {

  },
  methods: {
    tabClick(tab) {
      this.$store.dispatch('SET_PANELNAME', tab.name)
    }
  }
}
</script>
<style lang="scss">
  .forDetail{
    color:#6d9eeb;
    cursor: pointer;
    &:hover{
      text-decoration: underline;
      color: #4183ea;
    }
  }
</style>
